import { registerLocaleData } from '@angular/common'
import localePt from '@angular/common/locales/pt'
registerLocaleData(localePt, 'pt')
import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core'
import { FlexLayoutModule } from '@ngbracket/ngx-layout'
import { MatDialogModule } from '@angular/material/dialog'
import { ServiceWorkerModule } from '@angular/service-worker'
import { UnespCoreHomeModule, UnespCoreModule } from '@unesp/core'
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask'
import { environment } from 'src/environments/environment'
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha-2'

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { menu } from './menu'
import { InterceptorsModule } from './interceptors/interceptors.module'

import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { HttpClientModule } from '@angular/common/http'
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatIconModule } from '@angular/material/icon'
import { MatButtonModule } from '@angular/material/button'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatRadioModule } from '@angular/material/radio'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatCardModule } from '@angular/material/card'
import { MatTableModule } from '@angular/material/table'
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator'
import { MatSelectModule } from '@angular/material/select'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatDividerModule } from '@angular/material/divider'
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core'
import { PtBrMatPaginatorIntl } from './pt-br-paginator-intl'
import { MatSortModule } from '@angular/material/sort'
import { MatChipsModule } from '@angular/material/chips'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatTabsModule } from '@angular/material/tabs'
import { MatMenuModule } from '@angular/material/menu'

import { HomeComponent } from './modules/comum/home/home.component'
import { AjudaSuporteComponent } from './modules/comum/suporte/ajuda-suporte.component'
import { DownloadAssetComponent } from './modules/comum/download/download-asset.component'
import { PdfViewerComponent } from './modules/comum/pdf-viewer/pdf-viewer.component'
import { PlanoViewerComponent } from './modules/comum/plano-viewer/plano-viewer.component'
import { DocumentosViewerComponent } from './modules/comum/documentos-viewer/documentos-viewer.component'
import { AlertaCargaHorariaSisgradComponent } from './modules/comum/alerta-carga-horaria-sisgrad/alerta-carga-horaria-sisgrad.component'
import { CentralAcessosHomeComponent } from './modules/comum/central-acessos-home/central-acessos-home.component'
import { CertificadoValidadorComponent } from './modules/comum/certificado-validador/certificado-validador.component'

import { DepartamentoInformacaoProcedimentoComponent } from './modules/departamento/departamento-informacao-procedimento/departamento-informacao-procedimento.component'
import { DepartamentoLiberarDisciplinaComponent } from './modules/departamento/departamento-liberar-disciplina/departamento-liberar-disciplina.component'
import { DepartamentoAprovarInscricaoComponent } from './modules/departamento/departamento-aprovar-inscricao/departamento-aprovar-inscricao.component'
import { DepartamentoAnalisarInscricaoComponent } from './modules/departamento/departamento-analisar-inscricao/departamento-analisar-inscricao.component'
import { DepartamentoAprovarPlanoComponent } from './modules/departamento/departamento-aprovar-plano/departamento-aprovar-plano.component'
import { DepartamentoAnalisarPlanoComponent } from './modules/departamento/departamento-analisar-plano/departamento-analisar-plano.component'
import { DepartamentoHomologarRelatorioComponent } from './modules/departamento/departamento-homologar-relatorio/departamento-homologar-relatorio.component'
import { DepartamentoAnalisarRelatorioComponent } from './modules/departamento/departamento-analisar-relatorio/departamento-analisar-relatorio.component'
import { DepartamentoPlanoEntregueComponent } from './modules/departamento/departamento-plano-entregue/departamento-plano-entregue.component'
import { DepartamentoRelatorioEntregueComponent } from './modules/departamento/departamento-relatorio-entregue/departamento-relatorio-entregue.component'
import { DepartamentoStatusInscritosComponent } from './modules/departamento/departamento-status-inscritos/departamento-status-inscritos.component'
import { DepartamentoDisciplinaLiberadaComponent } from './modules/departamento/departamento-disciplina-liberada/departamento-disciplina-liberada.component'

import { PropgStatusInscricaoComponent } from './modules/propg/propg-status-inscricao/propg-status-inscricao.component'
import { PropgListaPerfilComponent } from './modules/propg/perfis/lista-perfil/lista-perfil.component'
import { PropgListaPerfilPorUsuarioComponent } from './modules/propg/perfis/lista-perfil-por-usuario/lista-perfil-por-usuario.component'
import { PropgAdicionaPerfilComponent } from './modules/propg/perfis/adiciona-perfil/adiciona-perfil.component'
import { PropgInscricoesComponent } from './modules/propg/propg-inscricoes/propg-inscricoes.component'
import { PropgAlunoPaadesComponent } from './modules/propg/propg-aluno-paades/propg-aluno-paades.component'
import { ConsultaLogComponent } from './modules/propg/consulta-log/consulta-log.component'
import { LogDetalhesComponent } from './modules/propg/consulta-log/log-detalhes/log-detalhes.component'

import { DiscenteDuvidaComponent } from './modules/discente/discente-duvida/discente-duvida.component'
import { DiscenteInscricaoComponent } from './modules/discente/discente-inscricao/discente-inscricao.component'
import { DiscenteInformacaoProcedimentoComponent } from './modules/discente/discente-informacao-procedimento/discente-informacao-procedimento.component'
import { DiscenteCargaHorariaComponent } from './modules/discente/discente-carga-horaria/discente-carga-horaria.component'
import { DiscenteCargaHorariaPrevistaComponent } from './modules/discente/discente-carga-horaria-prevista/discente-carga-horaria-prevista.component'
import { DiscenteModeloPlanoAtividadesComponent } from './modules/discente/discente-modelo-plano-atividades/discente-modelo-plano-atividades.component'
import { DiscentePlanoAtividadeComponent } from './modules/discente/discente-plano-atividade/discente-plano-atividade.component'
import { DiscentePlanoAtividadeEntregarComponent } from './modules/discente/discente-plano-atividade-entregar/discente-plano-atividade-entregar.component'
import { DiscenteModeloRelatorioAtividadesComponent } from './modules/discente/discente-modelo-relatorio-atividades/discente-modelo-relatorio-atividades.component'
import { DiscenteRelatorioAtividadeComponent } from './modules/discente/discente-relatorio-atividade/discente-relatorio-atividade.component'
import { DiscenteRelatorioAtividadeEntregarComponent } from './modules/discente/discente-relatorio-atividade-entregar/discente-relatorio-atividade-entregar.component'
import { DiscenteEmissaoCertificadoComponent } from './modules/discente/discente-emissao-certificado/discente-emissao-certificado.component'
import { DiscenteStatusInscricaoComponent } from './modules/discente/discente-status-inscricao/discente-status-inscricao.component'

import { DocenteInformacaoProcedimentoComponent } from './modules/docente/docente-informacao-procedimento/docente-informacao-procedimento.component'
import { DocenteAprovarCargaHorariaComponent } from './modules/docente/docente-aprovar-carga-horaria/docente-aprovar-carga-horaria.component'
import { DocenteAprovarCargaHorariaEfetivaComponent } from './modules/docente/docente-aprovar-carga-horaria-efetiva/docente-aprovar-carga-horaria-efetiva.component'
import { DocenteAprovarRelatorioAtividadesComponent } from './modules/docente/docente-aprovar-relatorio-atividades/docente-aprovar-relatorio-atividades.component'
import { DocenteAnalisarRelatorioAtividadesComponent } from './modules/docente/docente-analisar-relatorio-atividades/docente-analisar-relatorio-atividades.component'
import { DocenteEmissaoCertificadoComponent } from './modules/docente/docente-emissao-certificado/docente-emissao-certificado.component'
import { DocenteRelatorioEntregueComponent } from './modules/docente/docente-relatorio-entregue/docente-relatorio-entregue.component'
import { DocentePlanoEntregueComponent } from './modules/docente/docente-plano-entregue/docente-plano-entregue.component'
import { DocenteStatusInscricaoComponent } from './modules/docente/docente-status-inscricao/docente-status-inscricao.component'

import { StpgStatusInscricaoComponent } from './modules/stpg/stpg-status-inscricao/stpg-status-inscricao.component'
import { StpgInscricoesComponent } from './modules/stpg/stpg-inscricoes/stpg-inscricoes.component'

import { ConsultaStatusInscricaoComponent } from './modules/consulta/consulta-status-inscricao/consulta-status-inscricao.component'
import { PesquisaUsuarioComponent } from './modules/propg/pesquisa-usuario/pesquisa-usuario.component'
import { PropgEditarResponsaveisInscricaoComponent } from './modules/propg/propg-status-inscricao/propg-editar-responsaveis-inscricao/propg-editar-responsaveis-inscricao.component'
import { PesquisaDepartamentoComponent } from './modules/propg/pesquisa-departamento/pesquisa-departamento.component'

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AjudaSuporteComponent,
    DownloadAssetComponent,
    PdfViewerComponent,
    PlanoViewerComponent,
    DocumentosViewerComponent,
    AlertaCargaHorariaSisgradComponent,
    CentralAcessosHomeComponent,
    CertificadoValidadorComponent,
    DepartamentoInformacaoProcedimentoComponent,
    DepartamentoLiberarDisciplinaComponent,
    DepartamentoAprovarInscricaoComponent,
    DepartamentoAnalisarInscricaoComponent,
    DepartamentoAprovarPlanoComponent,
    DepartamentoAnalisarPlanoComponent,
    DepartamentoHomologarRelatorioComponent,
    DepartamentoAnalisarRelatorioComponent,
    DepartamentoPlanoEntregueComponent,
    DepartamentoRelatorioEntregueComponent,
    DepartamentoStatusInscritosComponent,
    DepartamentoDisciplinaLiberadaComponent,
    PropgStatusInscricaoComponent,
    PropgEditarResponsaveisInscricaoComponent,
    PropgListaPerfilComponent,
    PropgListaPerfilPorUsuarioComponent,
    PropgAdicionaPerfilComponent,
    PropgInscricoesComponent,
    PropgAlunoPaadesComponent,
    ConsultaLogComponent,
    LogDetalhesComponent,
    DiscenteDuvidaComponent,
    DiscenteInscricaoComponent,
    DiscenteInformacaoProcedimentoComponent,
    DiscenteCargaHorariaComponent,
    DiscenteCargaHorariaPrevistaComponent,
    DiscenteModeloPlanoAtividadesComponent,
    DiscentePlanoAtividadeComponent,
    DiscentePlanoAtividadeEntregarComponent,
    DiscenteModeloRelatorioAtividadesComponent,
    DiscenteRelatorioAtividadeComponent,
    DiscenteRelatorioAtividadeEntregarComponent,
    DiscenteEmissaoCertificadoComponent,
    DiscenteStatusInscricaoComponent,
    DocenteInformacaoProcedimentoComponent,
    DocenteAprovarCargaHorariaComponent,
    DocenteAprovarCargaHorariaEfetivaComponent,
    DocenteAprovarRelatorioAtividadesComponent,
    DocenteAnalisarRelatorioAtividadesComponent,
    DocenteEmissaoCertificadoComponent,
    DocenteRelatorioEntregueComponent,
    DocentePlanoEntregueComponent,
    DocenteStatusInscricaoComponent,
    StpgStatusInscricaoComponent,
    StpgInscricoesComponent,
    ConsultaStatusInscricaoComponent,
    PesquisaUsuarioComponent,
    PesquisaDepartamentoComponent,
  ],
  imports: [
    AppRoutingModule,
    UnespCoreModule,
    InterceptorsModule,
    UnespCoreHomeModule,
    MatDialogModule,
    NgxMaskDirective,
    NgxMaskPipe,
    FlexLayoutModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatToolbarModule,
    MatIconModule,
    MatSnackBarModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatTableModule,
    MatPaginatorModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSortModule,
    MatSlideToggleModule,
    MatDividerModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatTabsModule,
    MatMenuModule,
    RecaptchaV3Module,
  ],
  providers: [
    { provide: 'environment', useValue: environment },
    { provide: 'menu', useValue: menu },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
    { provide: MatPaginatorIntl, useValue: PtBrMatPaginatorIntl() },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptcha.siteKey },
    provideNgxMask(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
